var router = new VueRouter({
  mode: 'history', //to set it to html5mode, other value can be 'hash' for hashband method
  base: window.owConfig.apiBase, //this is needed in html5mode to calculate relative url
  routes: [
    {
      path: '/',
      name: 'home',
      component(resolve) {
        owLazyRoute('authentication', resolve);
      }
    },
    {
      path: '/partner',
      name: 'home',
      component(resolve) {
        owLazyRoute('authentication', resolve);
      }
    },
    {
      path: '/refresh',
      name: 'refresh',
      component(resolve) {
        owLazyRoute('refreshtoken', resolve);
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component(resolve) {
        owLazyRoute('logout', resolve);
      }
    },
    {
      path: '/kyc',
      name: 'kyc',
      component(resolve) {
        owLazyRoute('kyc', resolve);
      }
    },
    {
      path: '/kyc-submitted',
      name: 'kyc-submitted',
      component(resolve) {
        owLazyRoute('kyc-submitted', resolve);
      }
    },
    {
      path: '/data-privacy/:screen',
      name: 'data-privacy',
      component(resolve) {
        owLazyRoute('data-privacy', resolve);
      }
    },
    {
      path: '/2fa/:screen',
      name: '2fa',
      component(resolve) {
        owLazyRoute('2fa', resolve);
      }
    },
    {
      path: '/verify-email/:token',
      name: 'verify-email',
      component(resolve) {
        owLazyRoute('verify-email', resolve);
      }
    },
    {
      path: '/reset-password/:userId/:token',
      name: 'reset-password',
      component(resolve) {
        owLazyRoute('reset-password', resolve);
      }
    },
    {
      path: '/kyc-full',
      name: 'kyc-full-kyc',
      component(resolve) {
        owLazyRoute('kyc-full-kyc', resolve);
      }
    },
		{
			path: '/nop',
			name: 'kyc-full-kyc',
			component(resolve) {
				owLazyRoute('kyc-full-kyc', resolve);
			}
		},
    {
			path: '/manage-your-data/:screen',
			name: 'manage-your-data',
			component(resolve) {
				owLazyRoute('manage-your-data', resolve);
			}
    },
    {
      path: '/*',
      redirect: {
        name: 'home'
      }
    }
  ]
});
